import {getStyle} from "../functions/get_style";

const STYLE_SLIDE_ACTIVE = '-is-active';
const STYLE_SLIDE_ANIMATE_IN = '-animating-in';
const STYLE_SLIDE_ANIMATED_IN = '-animated-in';
const STYLE_SLIDE_INACTIVE = '-is-inactive';
const STYLE_SLIDE_ANIMATE_OUT = '-animating-out';
const STYLE_SLIDE_ANIMATED_OUT = '-animated-out';

export default class QuoteSlider {
    /**
     * @param {HTMLElement} container
     * @param {NodeList} slides
     * @param {number} index
     */
    constructor(container, slides, index = 0) {
        /**
         * @type {HTMLElement}
         * @private
         */
        this._container = container;

        /**
         * @type {NodeList<HTMLElement>}
         * @private
         */
        this._slides = slides;

        /**
         * @type {number}
         * @private
         */
        this._index = index;

        /**
         * @type {null|number}
         * @private
         */
        this._interval = null;

        this.init();
    }

    /**
     *
     */
    init() {
        this._slides.forEach((slide) => {
            this.deactivate(slide);
        });

        setTimeout(() => {
            this.animateIn(this._slides[this._index]);

            this.startInterval();
        }, 800);
    }

    startInterval() {
        this._interval = setInterval(() => {
            this.next();
        }, 5450);
    }

    /**
     * @param {HTMLElement} slide
     * @returns {number}
     */
    getHeight(slide) {
        let paddingBottom = getStyle(this._container, 'padding-bottom');

        paddingBottom = parseInt(paddingBottom);

        return slide.offsetHeight + paddingBottom;
    }

    /**
     * @param {number} height
     */
    setContainerHeight(height) {
        this._container.style.height = height + 'px';
    }

    nextIndex() {
        this._index += 1;

        if (this._index >= this._slides.length) {
            this._index = 0;
        }
    }

    next() {
        const active = this._index;

        // Index op volgende zetten.
        this.nextIndex();

        // Height vast zetten.
        this.setContainerHeight(
            this.getHeight(this._slides[active])
        );

        this.animateOut(this._slides[active], () => {
            this.animateIn(this._slides[this._index]);
        });

    }


    /**
     * @param {HTMLElement} slide
     */
    animateIn(slide) {
        this.setContainerHeight(this.getHeight(slide));

        slide.classList.remove(STYLE_SLIDE_ANIMATED_OUT);
        slide.classList.add(STYLE_SLIDE_ANIMATE_IN);

        setTimeout(() => {
            slide.classList.add(STYLE_SLIDE_ANIMATED_IN);
            slide.classList.remove(STYLE_SLIDE_ANIMATE_IN);

            this.activate(slide);
        }, 1450);
    }

    /**
     * @param {HTMLElement} slide
     * @param {Function} callback
     */
    animateOut(slide, callback) {
        slide.classList.remove(STYLE_SLIDE_ANIMATED_IN);
        slide.classList.add(STYLE_SLIDE_ANIMATE_OUT);

        setTimeout(() => {
            slide.classList.add(STYLE_SLIDE_ANIMATED_OUT);
            slide.classList.remove(STYLE_SLIDE_ANIMATE_OUT);

            this.deactivate(slide);

            setTimeout(() => {
                callback();
            }, 250);
        },1450);
    }

    /**
     * @param {HTMLElement} slide
     */
    activate(slide) {
        slide.classList.remove(STYLE_SLIDE_INACTIVE);
        slide.classList.add(STYLE_SLIDE_ACTIVE);
    }

    /**
     * @param {HTMLElement} slide
     */
    deactivate(slide) {
        slide.classList.remove(STYLE_SLIDE_ACTIVE);
        slide.classList.add(STYLE_SLIDE_INACTIVE);
    }
}